// extracted by mini-css-extract-plugin
export var divider = "_kp-0";
export var systemMessage = "_kp-1";
export var systemMessageWrapper = "_kp-2";